import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/api";
import { Logo } from "../components/Logo";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [form, setForm] = useState({ password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (form.password.length < 6) { setErr("Le mot de passe doit contenir au moins 6 caractères."); return; }
    if (form.password !== form.confirm) { setErr("Les deux mots de passe ne correspondent pas."); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password: form.password });
      setDone(true);
      toast.success("Mot de passe réinitialisé");
      setTimeout(() => nav("/connexion", { replace: true }), 1800);
    } catch (e2) {
      setErr(formatApiErrorDetail(e2.response?.data?.detail) || e2.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="pt-40 pb-32 min-h-[80vh] flex flex-col items-center px-6">
      <div className="mb-10"><Logo size="md" /></div>
      <div className="card-lux p-10 w-full max-w-md">
        <h1 className="font-display text-4xl mb-4 text-center" style={{ fontWeight: 300 }}>Nouveau mot de passe</h1>
        {!token ? (
          <div data-testid="reset-no-token">
            <p className="text-sm text-center leading-relaxed mb-8" style={{ color: "var(--lo-muted)" }}>
              Lien invalide ou incomplet. Veuillez refaire une demande de réinitialisation.
            </p>
            <Link to="/mot-de-passe-oublie" className="btn-primary h-14 w-full inline-flex items-center justify-center">Refaire une demande</Link>
          </div>
        ) : done ? (
          <p className="text-sm text-center leading-relaxed" data-testid="reset-success" style={{ color: "var(--lo-muted)" }}>
            Votre mot de passe a été réinitialisé. Redirection vers la connexion…
          </p>
        ) : (
          <>
            <p className="text-sm text-center leading-relaxed mb-8" style={{ color: "var(--lo-muted)" }}>
              Choisissez un nouveau mot de passe pour votre compte.
            </p>
            <form onSubmit={submit} className="space-y-5" data-testid="reset-form">
              <input required type="password" placeholder="Nouveau mot de passe" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="w-full bg-transparent border-b py-3 text-sm outline-none" style={{ borderColor: "var(--lo-border)" }} data-testid="reset-password" />
              <input required type="password" placeholder="Confirmer le mot de passe" value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} className="w-full bg-transparent border-b py-3 text-sm outline-none" style={{ borderColor: "var(--lo-border)" }} data-testid="reset-confirm" />
              {err && <p className="text-xs" style={{ color: "#e08" }} data-testid="reset-error">{err}</p>}
              <button disabled={busy} className="btn-primary h-14 w-full disabled:opacity-50" data-testid="reset-submit">{busy ? "..." : "Réinitialiser mon mot de passe"}</button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
